import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import NflPosDataShowdown from "./NflPosDataShowdown";

const VALID = ["QB", "RB", "WR", "TE", "K", "DST"]; // ✅ add K

export default function NflPositionalDataShowdown() {
  const { pos } = useParams();
  const key = String(pos || "QB").toUpperCase();
  const safe = useMemo(() => (VALID.includes(key) ? key : "QB"), [key]);
  return <NflPosDataShowdown pos={safe} />;
}
